.reusable-button {
  margin-left: 10px;
}
